import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll'

import './Footer.scss';

import GetIcon from '../GetIcon/GetIcon';
import SubscribeModule from '../SubscribeModule/SubscribeModule';

class Footer extends Component {
  state = {}

  render() {
    let {className} = this.props;

    return (
        <footer className="footer">
          <div className="container-wrapper--grey900">
            <div className="content-container content-container--footer">
              <div className="footer-container">
                <div className="columns">
                  <div className="column-left">
                    <AnchorLink className="footer-logo-link" href="#intro" offset="60">
                      <div className="footer-logo-icon">
                        <GetIcon name="logo-unigine"/>
                      </div>
                    </AnchorLink>
                    <p>UNIGINE © 2005-2021. All rights reserved.</p>
                    <p>Legal Notice: All trademarks are the properties of their respective owners</p>
                  </div>

                  <div className="column-right">
                    <div className="social-container">
                      <p>To follow the hackathon news, join us on</p>
                      <ul className="social-list">
                        <li className="social-item">
                          <a className="social-link" target="_blank" href="https://discord.gg/gFN7w9b">
                            <GetIcon name="logo-circled-discord"/>
                          </a>
                        </li>
                        <li className="social-item">
                          <a className="social-link" target="_blank" href="https://www.youtube.com/unigine_official">
                            <GetIcon name="logo-circled-youtube"/>
                          </a>
                        </li>
                        <li className="social-item">
                          <a className="social-link" target="_blank" href="https://twitter.com/Unigine">
                            <GetIcon name="logo-circled-twitter"/>
                          </a>
                        </li>
                        <li className="social-item">
                          <a className="social-link" target="_blank" href="https://www.facebook.com/Unigine">
                            <GetIcon name="logo-circled-fb"/>
                          </a>
                        </li>
                      </ul>
                      
                    </div>

                    <div className="social-subscribe">
                      <a href="https://unigine.com/?sign-up-for-news=true#news" className="btn btn-green-white button--sign-in">Sign Up for UNIGINE News</a>
                    </div>
                    
                    {/* <SubscribeModule></SubscribeModule> */}
                  </div>
                  <div className="footer-mobile-text">
                    <p>UNIGINE © 2005-2020. All rights reserved.</p>
                    <p>Legal Notice: All trademarks are the properties of their respective owners</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
    );
  }
};

export default Footer;
